import { jsx as _jsx } from "react/jsx-runtime";
import { HomeBriefingWidget } from '@/widgets/home-briefing';
export function HomePage() {
    return (_jsx("div", { className: "p-4 md:p-6", children: _jsx(HomeBriefingWidget, {}) }));
}
